var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login_area_img"},[_vm._v(_vm._s(_vm.$t('Account.正在登录中')))])
}
var staticRenderFns = []

export { render, staticRenderFns }